// This is generated.  Alter it in blockGroups/filters/types/NestedListEntry.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { propertyName } = hNode;
    let [childDefinedSubDataDictionary, childDefinedPartialTypeDefinition] =
      hNode.children.reduce(
        (soFar, child) => {
          const [childSubDD = {}, childPartial = {}] =
            moduleRegistration
              .getHNodeType('filters', child.hNodeType)
              ?.asDataDictionary?.(child, context) || [];
          return [
            merge(soFar[0], childSubDD),
            Object.assign(soFar[1], childPartial),
          ];
        },
        [{}, {}],
      );

    // Wrap child definitions in an object schema that becomes the array's items schema
    const requiredChildKeys = Object.keys(
      childDefinedPartialTypeDefinition || {},
    );
    const itemSchema = Type.Object(childDefinedPartialTypeDefinition, {
      title: '0',
      'x-dataType': 'object',
      additionalProperties: true,
      required: requiredChildKeys,
    });
    const partialTypeDefinition = {
      [propertyName]: Type.Array(itemSchema, {
        'x-dataType': 'array',
        'x-propertyName': propertyName,
      }),
    };

    //And the given foreignKey exists on the parent object.
    return [childDefinedSubDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'filters',
  'NestedListEntry',
  module.exports,
);
